var React = require('react');

function Quotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#005A8B","d":"M.524 8.524C1.85 3.775 5.127.328 8.31.328c.256 0 .511.022.76.066a.508.508 0 0 1 .4.635l-.655 2.344a.511.511 0 0 1-.509.37l-.052-.002c-1.18 0-3.339 1.77-4.439 5.703a12.97 12.97 0 0 0-.124.482 5.749 5.749 0 0 1 4.042-.38 5.674 5.674 0 0 1 3.931 6.984 5.685 5.685 0 0 1-5.454 4.142c-.515 0-1.03-.072-1.53-.211-1.984-.555-3.476-2.203-4.201-4.64-.655-2.197-.638-4.857.044-7.297ZM21.436.33c.256 0 .511.02.76.065a.505.505 0 0 1 .4.634l-.656 2.345a.508.508 0 0 1-.508.369l-.052-.001c-1.18 0-3.339 1.77-4.439 5.703-.044.157-.085.316-.124.482a5.749 5.749 0 0 1 4.042-.381 5.674 5.674 0 0 1 3.93 6.984 5.685 5.685 0 0 1-5.454 4.142c-.515 0-1.03-.071-1.53-.21-1.984-.556-3.476-2.203-4.201-4.64-.654-2.198-.638-4.858.044-7.298C14.976 3.776 18.252.329 21.436.329Z"}));
}

Quotes.defaultProps = {"fill":"none","viewBox":"0 0 25 21"};

module.exports = Quotes;

Quotes.default = Quotes;
